import layout from '!css-loader!./layout.css';

export { default as theme } from './theme';

export default [layout];
